import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  InputGroup, Input, InputGroupAddon, InputGroupText,
  Row, Col, FormGroup,
  UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import Select from 'react-select';
import CheckboxFilter from '../../../../../shared/components/CheckboxFilter';
import { countriesBH } from '../../../../../shared/helpers/WVConstants';

const colourStyles = {
  multiValue: styles => ({
    ...styles,
    backgroundColor: '#70bbfd',
  }),
  multiValueLabel: styles => ({
    ...styles,
    color: 'white',
  }),
  multiValueRemove: styles => ({
    ...styles,
    color: 'white',
    ':hover': {
      backgroundColor: '#a2e1fd',
      color: '#70bbfd',
    },
  }),
};

const selectTheme = theme => ({
  ...theme,
  borderRadius: 0,
  spacing: {
    ...theme.spacing,
    controlHeight: 30,
    baseUnit: 2,
  },
});

const Actions = React.memo(({
  approvalStatusFilters,
  setApprovalStatusFilters,
  justificationFilters,
  setJustificationFilters,
  onSearchChange,
  searchValue,
  onCategoryChange,
  categoryValue,
  selectedCountries,
  onCountryChange,
  searchQuery,
}) => {
  const [search, setSearch] = useState(searchValue);
  const [category, setCategory] = useState(categoryValue);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [categoryTimeout, setCategoryTimeout] = useState(null);

  const countryOpt = Object.entries(countriesBH()).map(entry => ({ value: entry[0], label: entry[1] }));
  countryOpt.unshift({ value: 'null', label: '-- Not Assigned --' });

  useEffect(() => {
    if (searchTimeout) clearTimeout(searchTimeout);
    setSearchTimeout(setTimeout(() => {
      onSearchChange(search);
    }, 500));
  }, [search]);

  useEffect(() => {
    if (categoryTimeout) clearTimeout(categoryTimeout);
    setCategoryTimeout(setTimeout(() => {
      onCategoryChange(category);
    }, 500));
  }, [category]);

  return (
    <div>
      <Row className="mb-2">
        <Col md={4}>
          <Row noGutters>
            <Col md={6} className="pr-1">
              <CheckboxFilter
                filterProp={approvalStatusFilters}
                filterTitle="Approval Status"
                filterAction={({ data }) => setApprovalStatusFilters(data)}
                classname="btn-sm w-100"
              />
            </Col>
            <Col md={6} className="pl-1">
              <CheckboxFilter
                filterProp={justificationFilters}
                filterTitle="Justification"
                filterAction={({ data }) => setJustificationFilters(data)}
                classname="btn-sm w-100"
              />
            </Col>
          </Row>
        </Col>
        <Col md={8}>
          <UncontrolledButtonDropdown className="mt-2 float-right">
            <DropdownToggle caret color="primary">
              Actions
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => window.open(`/resources/cpm-prospects/download-csv?${searchQuery}`, '_blank').focus()}>
                Download CSV
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <InputGroup>
            <Input
              name="search"
              type="search"
              autoComplete="off"
              placeholder="Search Creator"
              value={search}
              onChange={p => setSearch(p.target.value)}
              className="form-control-sm form-control ml-2"
            />
            <InputGroupAddon addonType="append">
              <InputGroupText>
                <i
                  className="fa fa-search"
                  aria-hidden="true"
                  style={{ color: '#70bbfd', fontSize: 12 }}
                />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </Col>
        <Col md={4}>
          <InputGroup size="sm">
            <Input
              name="category"
              type="search"
              autoComplete="off"
              placeholder="Search by Category"
              value={category}
              onChange={p => setCategory(p.target.value)}
            />
            <InputGroupAddon addonType="append">
              <InputGroupText>
                <i
                  className="fa fa-search"
                  aria-hidden="true"
                  style={{ color: '#70bbfd', fontSize: 12 }}
                />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="mb-0">
            <Select
              isMulti
              name="countrySelect"
              isClearable
              value={countryOpt.filter(opt => selectedCountries.includes(opt.value))}
              options={countryOpt}
              onChange={onCountryChange}
              placeholder="Country (COR)"
              styles={colourStyles}
              theme={selectTheme}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
});

Actions.propTypes = {
  approvalStatusFilters: PropTypes.objectOf(PropTypes.bool).isRequired,
  setApprovalStatusFilters: PropTypes.func.isRequired,
  justificationFilters: PropTypes.objectOf(PropTypes.bool).isRequired,
  setJustificationFilters: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  categoryValue: PropTypes.string.isRequired,
  selectedCountries: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCountryChange: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
};

export default Actions;
